import Backbone from "backbone";
import _ from "underscore";
import SecurityKeyModel from "src/shared/security-keys/SecurityKeyModel";

const SecurityKeycollection = Backbone.Collection.extend({
    url: "/api/v2/settings/security/keys",
    model: SecurityKeyModel,

    initialize(attributes, options) {
        this.type = options && options.type;
    },

    parse(data) {
        const filteredCollection = _.filter(data, (model) => {
            if (this.type) {
                return model.type === this.type;
            }
            return model.type !== "PGP_EXTOLE";
        });

        return filteredCollection;
    },
});

SecurityKeycollection.create = function (type) {
    return new SecurityKeycollection(null, {
        type,
    });
};

export default SecurityKeycollection;
